import { Component } from '@angular/core';

import { interchangesSegmentData } from '../../../segment-data/interchanges-segment-data';

import { BaseScorecardListComponent } from '../base/_base-scorecard-list.component';


@Component({
  moduleId: module.id,
  selector: 'interchanges-scorecard',
  templateUrl: 'interchanges-scorecard.component.html',
})
export class InterchangesScorecardComponent extends BaseScorecardListComponent {
  segmentTitle: string = 'Interchanges';
  segmentName: string = 'interchanges';
  pathToScorecard = this.segmentName;
  pathToScorecardTitle = 'brand_label';
  segmentData: any = interchangesSegmentData;
}
